import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mediaType", "mediaFormat"]
  static values = { optionsByType: Object }

  connect() {
    this.updateFormatOptions()
  }

  mediaTypeChanged() {
    this.updateFormatOptions()
  }

  updateFormatOptions() {
    if (!this.hasMediaTypeTarget || !this.hasMediaFormatTarget) {
      return
    }

    const selectedType = this.mediaTypeTarget.value
    const optionsForType = this.optionsByTypeValue[selectedType] || []
    const existingValue = this.mediaFormatTarget.value

    this.mediaFormatTarget.innerHTML = ""
    this.mediaFormatTarget.append(this.buildOption("N/A", ""))

    optionsForType.forEach((value) => {
      this.mediaFormatTarget.append(this.buildOption(this.humanize(value), value))
    })

    const validValues = new Set(["", ...optionsForType])
    this.mediaFormatTarget.value = validValues.has(existingValue) ? existingValue : ""
  }

  buildOption(label, value) {
    const option = document.createElement("option")
    option.textContent = label
    option.value = value
    return option
  }

  humanize(value) {
    return value
      .toString()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }
}
